import {
    convertCurrencyFormatPositiveNegative, convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoBaseContainer, RaikoChipTypes, RaikoCustomSimpleChip, RaikoGridFourColumn,
    RaikoGridOneColumn, RaikoGridThreeColumn, RaikoMaterialOutlinedInput, RaikoMoneyInputOutlined,
    RaikoSectionContainer,
    showErrorMessage,RaikoTableTitleContainer
} from "@moeindal/base-raiko-panel-components";
import {useParams} from "react-router-dom";
import {LoanService} from "../../../serverService/loan/LoanService";
import {useAuthState} from "../../../context/AuthContext";
import React, {useEffect, useRef, useState} from "react";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import PointsStatistics from "../../../raicheComponents/statistics/PointsStatistics";
import useDraggableScroll from "use-draggable-scroll";
import {css} from "@emotion/css";
import RaikoCardInfoTypeOne, {
    RaikoCardInfoTypeOneItemGenerator, RaikoCardInfoTypeOneStatusTypes
} from "../../../raikoComponents/raikoCardInfo/RaikoCardInfoTypeOne";

export default function LoanDetailBasicInfo({setReceiptUrl}) {

    const {id: loanId} = useParams()

    const {fundID} = useAuthState()

    const service = new LoanService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});

    useEffect(() => {
        getLoanDetailFromServer()
    }, [loanId]);

    const [loanPayInfo, setLoanPayInfo] = useState({
        numberOfDeferredInstallments: "",
        numberOfPaidInstallments: "",
        numberOfUnpaidInstallments: "",
        status: "",
        summationOfDeferredInstallment: "",
        summationOfPaidInstallments: "",
        summationOfUnpaidInstallments: "",
    })

    const [loanDetail, setLoanDetail] = useState({
        IBAN: "",
        ibanOwner: "",
        amount: 0,
        amountOfCommission: 0,
        balance: 0,
        bankAccountNumber: "",
        createdAt: "",
        createdBy: "",
        depositAccountNumber: "",
        firstName: "",
        grantDate: "",
        groupName: "",
        id: 0,
        installments: [],
        lastName: "",
        loanKind: "",
        nationalCode: "",
        numberOfInstallments: 0,
        paymentMaturity: "",
        receiptUrl: "",
        withdrawalAmountFromTheAccount: ""
    })

    function getLoanDetailFromServer() {
        loading.show()
        service.getDetail(
            fundID,
            loanId
        ).then(({loanStatusResponse, loanDetailResponse}) => {
            setLoanPayInfo(loanStatusResponse)
            setLoanDetail(loanDetailResponse)
            setReceiptUrl(loanDetailResponse.receiptUrl)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function ignoreIt() {
        // nothing to do
    }

    return (
        <RaikoGridOneColumn className={css`gap: 1.5rem;`}>

            {/* <RaikoBaseCardContainer>
                <div className={css`
                  display: flex;
                  justify-content: space-between;
                  gap: 1rem;
                  align-items: center;
                `}
                >
                    <RaikoLabel className={css`font-weight: 900`} text={"در حال پرداخت"}/>
                    {
                        loanPayInfo.status === "PAYING" ?
                            <RaikoCustomSimpleChip title={"در حال پرداخت"} type={RaikoChipTypes.warning}/> :
                            <RaikoCustomSimpleChip title={"در حال پرداخت"} type={RaikoChipTypes.warning}/>
                    }
                </div>
            </RaikoBaseCardContainer>*/}

            <div className="statisticsLayout hideScroll" ref={ref} onMouseDown={onMouseDown}>

                <PointsStatistics
                    title={`${loanPayInfo.numberOfPaidInstallments} قسط پرداخت شده`}
                    amount={`${convertCurrencyFormatPositiveNegative(loanPayInfo.summationOfPaidInstallments)} ریال`}
                    iconFile={""}
                />

                <PointsStatistics
                    title={`${loanPayInfo.numberOfUnpaidInstallments} قسط پرداخت نشده`}
                    amount={`${convertCurrencyFormatPositiveNegative(loanPayInfo.summationOfUnpaidInstallments)} ریال`}
                    iconFile={""}
                />

                <PointsStatistics
                    title={`${loanPayInfo.numberOfDeferredInstallments} قسط معوقه`}
                    amount={`${convertCurrencyFormatPositiveNegative(loanPayInfo.summationOfDeferredInstallment)} ریال`}
                    iconFile={""}
                />
            </div>


            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات حساب"}
                >
                    <RaikoGridFourColumn>

                        <RaikoMaterialOutlinedInput
                            labelText={"نام"}
                            value={loanDetail.firstName}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"نام خانوادگی"}
                            value={loanDetail.lastName}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"کد ملی"}
                            value={loanDetail.nationalCode}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"گروه"}
                            value={loanDetail.groupName}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"شناسه حساب"}
                            value={loanDetail.depositAccountNumber}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"موجودی حساب (ریال)"}
                            value={convertCurrencyFormatPositiveNegative(loanDetail.balance)}
                            setValue={ignoreIt}
                            disabled
                        />
                    </RaikoGridFourColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات وام"}
                >
                    <RaikoGridThreeColumn>

                        <RaikoMaterialOutlinedInput
                            labelText={"شناسه درخواست"}
                            value={loanDetail.id}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"مبلغ وام (ریال)"}
                            value={convertCurrencyFormatPositiveNegative(loanDetail.amount)}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"کارمزد (ریال)"}
                            value={convertCurrencyFormatPositiveNegative(loanDetail.amountOfCommission)}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"تعداد اقساط"}
                            value={loanDetail.numberOfInstallments}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"نوع وام"}
                            value={loanDetail.loanKind}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"مبلغ کسر شده از موجودی (ریال)"}
                            value={convertCurrencyFormatPositiveNegative(loanDetail.withdrawalAmountFromTheAccount)}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"تاریخ پرداخت"}
                            value={convertUniversalDateTimeToPersianDateTime(loanDetail.grantDate)}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"سررسید اولین قسط"}
                            value={convertUniversalDateTimeToPersianDateTime(loanDetail.paymentMaturity)}
                            setValue={ignoreIt}
                            disabled
                        />
                    </RaikoGridThreeColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>


            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پرداخت"}
                >
                    <RaikoGridFourColumn>

                        <RaikoMaterialOutlinedInput
                            labelText={"پرداخت کننده"}
                            value={loanDetail.createdBy}
                            setValue={ignoreIt}
                            disabled
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"تاریخ ثبت"}
                            value={convertUniversalDateTimeToPersianDateTime(loanDetail.createdAt)}
                            setValue={ignoreIt}
                            disabled
                        />

                        <RaikoMaterialOutlinedInput
                            labelText={"مالک حساب"}
                            value={loanDetail.ibanOwner}
                            setValue={ignoreIt}
                            disabled
                        />

                        <RaikoMaterialOutlinedInput
                            labelText={"شماره شبا"}
                            value={loanDetail.IBAN}
                            setValue={ignoreIt}
                            disabled
                        />

                    </RaikoGridFourColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoTableTitleContainer
                        title={"اقساط"}
                        amount={loanDetail.installments.length}
                    />
                    {
                        loanDetail && loanDetail.installments && loanDetail.installments.length > 0 ?
                            loanDetail.installments.map((item, index) => {
                                return <RaikoCardInfoTypeOne
                                    title={convertUniversalDateTimeToPersianDateTime(item.dateOfPayment)}
                                    titleLabel={"سررسید"}
                                    status={true}
                                    statusText={item.paid ? "پرداخت شده" : "پرداخت نشده"}
                                    statusType={item.paid ? RaikoCardInfoTypeOneStatusTypes.SUCCESS : RaikoCardInfoTypeOneStatusTypes.ERROR}
                                    items={item.paidAt ? [
                                        RaikoCardInfoTypeOneItemGenerator("شناسه قسط", item.id),
                                        RaikoCardInfoTypeOneItemGenerator("مبلغ قسط (ریال)", convertCurrencyFormatPositiveNegative(item.amount)),
                                        RaikoCardInfoTypeOneItemGenerator("کارمزد (ریال)", convertCurrencyFormatPositiveNegative(item.amountOfCommission)),
                                        RaikoCardInfoTypeOneItemGenerator("مبلغ کمکی (ریال)", convertCurrencyFormatPositiveNegative(item.auxiliaryAmount)),
                                        RaikoCardInfoTypeOneItemGenerator("قابل پرداخت (ریال)", convertCurrencyFormatPositiveNegative(item.amountPayable)),
                                        RaikoCardInfoTypeOneItemGenerator("پرداخت شده (ریال)", convertCurrencyFormatPositiveNegative(item.amountPaid)),
                                        RaikoCardInfoTypeOneItemGenerator("باقی مانده (ریال)", convertCurrencyFormatPositiveNegative(item.amountPayable - item.amountPaid)),
                                        RaikoCardInfoTypeOneItemGenerator("تاریخ پرداخت", convertUniversalDateTimeToPersianDateTime(item.paidAt)),
                                        RaikoCardInfoTypeOneItemGenerator("پرداخت کننده", item.paidByManger ? item.paidByManger : item.paidByMember),
                                    ] : [
                                        RaikoCardInfoTypeOneItemGenerator("شناسه قسط", item.id),
                                        RaikoCardInfoTypeOneItemGenerator("مبلغ قسط (ریال)", convertCurrencyFormatPositiveNegative(item.amount)),
                                        RaikoCardInfoTypeOneItemGenerator("کارمزد (ریال)", convertCurrencyFormatPositiveNegative(item.amountOfCommission)),
                                        RaikoCardInfoTypeOneItemGenerator("مبلغ کمکی (ریال)", convertCurrencyFormatPositiveNegative(item.auxiliaryAmount)),
                                        RaikoCardInfoTypeOneItemGenerator("پرداخت شده (ریال)", convertCurrencyFormatPositiveNegative(item.amountPaid)),
                                        RaikoCardInfoTypeOneItemGenerator("قابل پرداخت (ریال)", convertCurrencyFormatPositiveNegative(item.amountPayable)),
                                    ]}
                                    hasBottomChildren
                                />
                            }) :
                            <RaikoGridOneColumn>

                            </RaikoGridOneColumn>
                    }
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}
